import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, KeyLog} from '../../../types/data.types';
import {NoticesService} from '../../../services/notices.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'create-notice-wizard',
    templateUrl: './create-notice-wizard.component.html',
    styleUrls: ['./create-notice-wizard.component.scss']
})
export class CreateNoticeWizardComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: KeyLog = new KeyLog();
    disabledSubmit = false;
    buildingSelectIsDisabled = false;

    static parseTime(dateString: string): string {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    constructor(
        public api: ApiClientService,
        public noticesService: NoticesService
    ) {}

    ngOnInit() {
        setTimeout( () => this.showModal = true, 300);
    }

    hideModal() {
        this.noticesService.isNoticeWizardShow = false;
    }

    wizardType(wizardType): void {
        this.noticesService.wizardType = wizardType;
        this.noticesService.step = wizardType == 'scratch' ? 'message' : 'templates';
        this.noticesService.choosingTemplate = wizardType == 'templates' ? true : false;
        this.noticesService.isNoticeWizardShow = false;
        this.noticesService.isNoticeModalShow = true;
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/notices/create-notice-wizard/create-notice-wizard.component.ts